import { render, staticRenderFns } from "./AlertBrowserIE.vue?vue&type=template&id=f0a40312&scoped=true&"
import script from "./AlertBrowserIE.vue?vue&type=script&lang=js&"
export * from "./AlertBrowserIE.vue?vue&type=script&lang=js&"
import style0 from "./AlertBrowserIE.vue?vue&type=style&index=0&id=f0a40312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a40312",
  null
  
)

export default component.exports